import { useSyncExternalStore } from 'react';

/**
 * 안내 투어가 <b>대신 열어 두는</b> 판 — 옆판(drawer)·모달처럼 눌러야 나타나는 것들.
 *
 * <h2>왜 필요한가 (사용자 지시 2026-08-26)</h2>
 * 「누르면 왼쪽에서 목록이 나옵니다」 까지만 말하는 안내는 정작 <b>그 목록이 무엇인지</b>를 설명하지
 * 못한다. 그렇다고 사람에게 열어 보라고 할 수도 없다 — 투어 중에는 막이 클릭을 삼키고, 반대로 판이
 * 열려 있을 때는 <b>? 버튼이 그 판에 가려 눌리지 않는다.</b> 열어 놓고 안내를 시작하는 길도 없다.
 *
 * <p>그래서 걸음이 «이 판을 열어 둬라» 를 여기 올려 두고, 화면이 그것을 자기 열림 상태에 <b>얹어</b>
 * 읽는다({@link useTourPanelOpen}). 사람이 눌러 연 상태는 건드리지 않으므로, 안내가 끝나면 원래대로
 * 돌아온다. 사이드바를 대신 펼치는 {@code expanded.ts} 와 같은 규율이고, 이유도 같다.
 *
 * <p>이름은 <b>그 판을 여는 버튼의 {@code data-tour}</b> 와 같게 쓴다(`nas-picker`). 걸음이 가리키는
 * 자리와 여는 자리가 같은 이름이면, 대본만 보고도 무엇이 열리는지 읽힌다.
 */

let openKeys: readonly string[] = [];
const listeners = new Set<() => void>();

export function setTourOpenPanels(next: readonly string[]): void {
  // 같은 값으로 알리면 그 화면이 매 걸음 헛되이 다시 그려진다.
  if (next.length === openKeys.length && next.every((key, i) => key === openKeys[i])) return;

  openKeys = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** 지금 걸음이 이 판을 열어 두라고 했는가. 화면은 자기 상태와 <b>OR</b> 로 읽는다. */
export function useTourPanelOpen(key: string): boolean {
  return useSyncExternalStore(
    subscribe,
    () => openKeys.includes(key),
    () => false,
  );
}
